import { useEffect } from "react";
import { useLocation } from "react-router";

import {
  applicationNavigationKey,
  reportApplicationWorkspaceCommit,
} from "./applicationTelemetry";
import { sessionManager } from "./session";

// Place inside the content side of Suspense, never alongside its fallback.
export function ApplicationWorkspaceCommit({
  moduleKey,
}: {
  moduleKey?: string;
}) {
  const location = useLocation();
  useEffect(() => {
    const session = sessionManager.getSnapshot();
    if (!session) return;
    const scope = `${session.tenant.id}:${session.user.id}`;
    reportApplicationWorkspaceCommit(
      applicationNavigationKey(scope, location.key),
      moduleKey,
    );
  }, [location.key, moduleKey]);
  return null;
}
